<!-- 已办 -->
<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <!-- <a-col :xl="5" :lg="7" :md="8" :sm="24">
            <a-form-item label="状态">
              <a-select placeholder="请选择状态" v-model="queryParam.applyState">
                <a-select-option :value="0">待审批</a-select-option>
                <a-select-option :value="1">待评价</a-select-option>
                <a-select-option :value="2">结束</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户编号')">
              <a-input v-model="queryParam.userId" :placeholder="$t('请输入用户编号查询')" />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户姓名')">
              <a-input v-model="queryParam.userName" :placeholder="$t('请输入用户姓名查询')" />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户电话')">
              <a-input v-model="queryParam.userPhone" :placeholder="$t('请输入用户电话查询')" />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('申请类型')">
              <a-select :placeholder="$t('请选择申请类型')" v-model="queryParam.applyType">
                <a-select-option :value="0">{{ $t('报停') }}</a-select-option>
                <a-select-option :value="1">{{ $t('报停恢复') }}</a-select-option>
                <a-select-option :value="2">{{ $t('销户') }}</a-select-option>
                <a-select-option :value="3">{{ $t('用户信息变更') }}</a-select-option>
                <a-select-option :value="4">{{ $t('用水性质变更') }}</a-select-option>
                <a-select-option :value="5">{{ $t('用户过户') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- table区域-begin -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">
    
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="ticketsNum" slot-scope="text,record">
          <a-button type="link" size="small" @click="onWork(record)" v-if="record.ticketsNum">{{ record.ticketsNum }}</a-button>
        </template>
        <template slot="applyType" slot-scope="text,record">
          {{record.applyType==0?$t('报停'):record.applyType==1?$t('报停恢复'):record.applyType==2?$t('销户'):record.applyType==3?$t('用户信息变更'):record.applyType==4?$t('变更用水性质'):record.applyType==5?$t('用户过户'):''}}
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleApprovalHistory(record)">{{ $t('审批历史') }}</a>
          <a-divider type="vertical" />
          <a @click="handleReviews(record)">{{ $t('查看反馈') }}</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>

    <Modal ref="modalForm" @ok="modalFormOk"></Modal>
    <handleModal ref="hanldeModalForm" @ok="modalFormOk"></handleModal>
    <rateModal ref="rateModalForm" @ok="modalFormOk"></rateModal>
    <approvalHistoryModal ref="approvalHistoryModalForm" />
    <TearDownAndInstallOrderApprove ref="tearDownAndInstallOrderApproveForm" @ok="modalFormOk"></TearDownAndInstallOrderApprove>
     <!-- 用户信息变更 -->
    <UserInfoChange ref="userInfoChangeForm" @ok="modalFormOk"></UserInfoChange>
    <!-- 用水性质变更 -->
    <UseWaterChange ref="useWaterChangeForm" @ok="modalFormOk"></UseWaterChange>
    <!-- 过户 -->
    <TransferUser ref="transferUserForm" @ok="modalFormOk"></TransferUser>
    <!-- 销户 -->
    <CloseUserAccount ref="closeUserAccountForm" @ok="modalFormOk"></CloseUserAccount>
  </div>
</template>

<script>
  import JInput from '@/components/jeecg/JInput'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import Modal from './modal'
  import handleModal from './handleModal'
  import rateModal from './rateModal'
  import TearDownAndInstallOrderApprove from './TearDownAndInstallOrderApprove.vue'
  import UserInfoChange from './modules/UserInfoChange.vue'
  import UseWaterChange from './modules/UseWaterChange.vue'
  import TransferUser from './modules/TransferUser.vue'
  import CloseUserAccount from './modules/CloseUserAccount.vue'
  import approvalHistoryModal from './approvalHistoryModal'
  import { postAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import moment from 'moment';
  import Vue from 'vue'
  import { SYS_TYPE } from "@/store/mutation-types"
  import store from '@/store/'

  export default {
    name: 'ConstructionDetailList',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      Modal,
      handleModal,
      rateModal,
      approvalHistoryModal,
      JInput,
      TearDownAndInstallOrderApprove,
      UserInfoChange,
      UseWaterChange,
      TransferUser,
      CloseUserAccount,
    },
    data () {
      return {
        url: {
          list: "/jeecg-charge/meter/wechatUserApply/list",
          delete: "/jeecg-charge/meter/wechatUserApply/delete",
          deleteBatch: "/jeecg-charge/meter/wechatUserApply/deleteBatch",
          // exportXlsUrl: "/jeecg-engineering/engineering/installationDetail/exportXls",
          // importExcelUrl: "jeecg-engineering/engineering/installationDetail/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
        disabledCurrentStart: null,
        disabledCurrentEnd: null,
        queryParam:{
          applyState:3
        }
      }
    },
    created() {},
    computed: {
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },
          // {
          //   title:'状态',
          //   align:"center",
          //   dataIndex: 'applyState',
          //   scopedSlots: { customRender: 'applyState' }
          // },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('用户电话'),
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('申请类型'),
            align:"center",
            dataIndex: 'applyType',
            scopedSlots: { customRender: 'applyType' },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('申请时间'),
            align:"center",
            dataIndex: 'applyTime',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('审批人'),
            align:"center",
            dataIndex: 'updateBy',
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('审批状态'),
            align:"center",
            dataIndex: 'isAgree',
            customRender: (t, r, index) => {
              if(t == 0){
                return this.$t('驳回')
              }else if(t == 1){
                return this.$t('通过')
              }else{
                return this.$t('撤销')
              }
            },
            width:150,
            ellipsis: true,
          },
          {
            title: this.$t('审批时间'),
            align:"center",
            dataIndex: 'updateTime',
            width:150,
            ellipsis: true,
          },{
            title: this.$t('关联工单'),
            align:"center",
            dataIndex: 'ticketsNum',
            width:180,
            ellipsis: true,
            scopedSlots: { customRender: 'ticketsNum' }
          },
          // {
          //   title:'处理人',
          //   align:"center",
          //   dataIndex: 'handleName',
          //   width:150,
          //   ellipsis: true,
          // },
          // {
          //   title:'处理时间',
          //   align:"center",
          //   dataIndex: 'handleTime',
          //   width:150,
          //   ellipsis: true,
          // },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:200,
            scopedSlots: { customRender: 'action' }
          },
        ];
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      searchReset(){
        this.queryParam = {
          applyState: 3
        };
        this.loadData();
      },
      handleDetail(row){
        // 报停0 复接1 详情页面
        if ([0, 1].includes(row.applyType)) {
          if (this.$refs.tearDownAndInstallOrderApproveForm) {
            this.$refs.tearDownAndInstallOrderApproveForm.init(row, "详情");
          } else {
            console.error('组件引用不存在，请检查组件是否已正确加载');
          }
          return;
        }else if(row.applyType == 3){
          // 用户信息变更 详情
          this.handleUserInfoChange(row,"detail")
        }else if(row.applyType == 5){
          // 过户
          this.handleTransferUser(row,"detail")
        }else if(row.applyType == 2){
          // 销户
          this.handleCloseUserAccountChange(row,"detail")
        }else if(row.applyType == 4){
          // 用水性质变更
          this.handleUseWaterChange(row,"detail")
        }

        // this.$nextTick(()=>{
        //   this.$refs.modalForm.init(row,'detail');
        // });
      },
       // 用户信息变更
      handleUserInfoChange(row,type){
        this.$nextTick(()=>{
          this.$refs.userInfoChangeForm.init(row,type);
        });
      },
      // 销户
      handleCloseUserAccountChange(row,type){
        this.$nextTick(()=>{
          this.$refs.closeUserAccountForm.init(row,type);
        });
      },
      // 用水性质变更
      handleUseWaterChange(row,type){
        this.$nextTick(()=>{
          this.$refs.useWaterChangeForm.init(row,type);
        });
      },
      // 过户
      handleTransferUser(row,type){
        this.$nextTick(()=>{
          this.$refs.transferUserForm.init(row,type);
        });
      },
      // 审批
      handleApproval(row){
        this.$nextTick(()=>{
          this.$refs.hanldeModalForm.init(row);
        });
      },
      // 查看评价
      handleReviews(row){
        this.$nextTick(()=>{
          this.$refs.rateModalForm.init(row);
        });
      },
      handleApprovalHistory(row){
        this.$nextTick(()=>{
          this.$refs.approvalHistoryModalForm.init(row);
        });
      },
      // 跳转工单记录
      onWork(row){
        // 左侧菜单跟随路由切换
        Vue.ls.set(SYS_TYPE,8);
        store.commit('SET_SYSTYPE', 8);
        // this.$router.replace({ path: "/workOrderManagement/workManagement/index",query:{ticketsNum:row.ticketsNum} });
        this.$router.push({ 
          path: "/workOrderManagement/workManagement/index",
          query: { ticketsNum: row.ticketsNum } 
        });

        // 打开一个页签，保留当前左侧菜单
        // this.$router.push({
        //   path: "/workOrderManagement/workManagement/index",
        //   query: { ticketsNum: row.ticketsNum }
        // });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>